import { AddFeedbackFormData } from '../../../interfaces/customer-simulator';
import { Button, Flex, Form, Input, ModalManagerContext, Select, Option } from '@pega/cosmos-react-core';
import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import useLocalTranslation from '../../../hooks/useLocalTranslation';
import { FeedbackResponseData } from '../../../constants/common';

interface AddFeedbackProps {
  handleFormSubmit: (data: AddFeedbackFormData) => void;
  feedback?: AddFeedbackFormData;
}

const AddFeedback: React.FC<AddFeedbackProps> = ({ handleFormSubmit, feedback }) => {
  const { register, handleSubmit, errors, formState } = useForm<AddFeedbackFormData>({
    mode: 'all',
    defaultValues: {
      name: feedback?.name || '',
      description: feedback?.description || '',
      responseType: feedback?.responseType,
    },
  });
  const translate = useLocalTranslation();
  const { ModalContext } = useContext(ModalManagerContext);
  const { dismiss } = useContext(ModalContext);

  const addRecord = (data: AddFeedbackFormData) => {
    let updatedData: AddFeedbackFormData = data;
    if (feedback) {
      updatedData = { ...updatedData, id: feedback.id };
    }
    const isValidData = data.name?.trim() && data.description?.trim();
    if (formState.isValid && isValidData) {
      handleFormSubmit(updatedData);
      dismiss();
    }
  };

  const handleOnSubmit = (event: any) => {
    event.preventDefault();
    handleSubmit(addRecord)();
  };

  const actions = (
    <>
      <Button onClick={dismiss}>{translate('cancel')}</Button>
      <Button variant="primary" disabled={!formState.isValid} onClick={handleOnSubmit}>
        {translate(feedback ? 'update' : 'add')}
      </Button>
    </>
  );

  return (
    <Form actions={actions}>
      <Flex
        container={{
          colGap: 2,
          direction: 'column',
          gap: 2,
        }}
      >
        <Input
          name="name"
          label={translate('name')}
          required={true}
          autoComplete="off"
          info={errors.name?.message}
          status={errors.name?.message ? 'error' : undefined}
          ref={register({ required: translate('title_empty') })}
        />
        <Select name="responseType" label={translate('response_type')} ref={register()}>
          {FeedbackResponseData.map((item) => (
            <Option value={item} key={item}>
              {item}
            </Option>
          ))}
        </Select>
        <Input
          name="description"
          label={translate('description')}
          autoComplete="off"
          required={true}
          type="text"
          info={errors.description?.message}
          status={errors.description?.message ? 'error' : undefined}
          ref={register({ required: translate('description_empty') })}
        />
      </Flex>
    </Form>
  );
};

export default AddFeedback;
